const Packages = {
    app: {
        name: "Appetizer",
        heading: "If you want a small taste.",
        id: "app",
        price: 3,
        //price: 0.50,
        credits: 5,
        words: 100,
        cls: "appetizer",
        iconCls: "simple-smile",
    },

    full: {
        name: "Full Course",
        heading: "If you're serious about finding a great name.",
        id: "full",
        price: 30,
        credits: 100,
        words: 1000,
        cls: "full-course",
        iconCls: "grin-hearts"
    },
};


export default Object.freeze(Packages);